'use strict'

import Helper from '@/utils/helper'
import SaleItem from '@/app/model/sale/sale-item'
import FiscalizationData from '@/app/model/sale/fiscalization-data'

class SaleInfo {
  constructor({items, totalSum, fiscalizationData}) {
    Helper.checkNotEmptyArray('SaleInfo.items', items)
    if (Helper.isDefined(fiscalizationData)) {
      Helper.checkIsNotEmpty('SaleInfo.fiscalizationData', fiscalizationData)
    }

    this.items = items.map((item) => new SaleItem(item))
    this.totalSum = totalSum
    this.fiscalizationData = fiscalizationData ? new FiscalizationData(fiscalizationData) : null
  }

  getItems() {
    return this.items
  }

  getTotalSum() {
    return this.totalSum
  }

  getFiscalizationData() {
    return this.fiscalizationData
  }

  toString() {
    return 'SaleInfo{' +
      'items=' + '\'' + this.items + '\'' +
      ', totalSum=' + '\'' + this.totalSum + '\'' +
      ', fiscalizationData=' + '\'' + this.fiscalizationData + '\'' +
      '}'
  }
}

export default SaleInfo
